export default __webpack_public_path__ + "static/media/location--6.34974315.jpg";